import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[pDynamicDialogFooter]',
})
export class DynamicDialogFooter {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
